// extracted by mini-css-extract-plugin
export var button = "notFound-module--button--VIQ7R";
export var icon = "notFound-module--icon--sHAic";
export var image = "notFound-module--image--flIn2";
export var left = "notFound-module--left--MfwGp";
export var right = "notFound-module--right--CSn4D";
export var section = "notFound-module--section--eSer9";
export var show = "notFound-module--show--bpIkr";